export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAW4AAAAGAQMAAADZvOZPAAAAA1BMVEX0pxDpRtycAAAADElEQVQY02MYBTgAAAEaAAH2uzipAAAAAElFTkSuQmCC"